import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { subscribeEmail } from "../../lib/subscribe";

export const NewsletterBand = ({ t, lang }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const subscribe = async (e) => {
    e.preventDefault();
    setBusy(true);
    const err = await subscribeEmail(email, lang);
    setBusy(false);
    if (err) return toast.error(t(err));
    toast.success(t("newsletter_thanks"));
    setEmail("");
  };
  return (
    <div className="border border-[#262421] bg-[#141311]/50 p-8 md:p-12 flex flex-col md:flex-row md:items-center justify-between gap-8" data-testid="newsletter-band">
      <div className="max-w-md">
        <h3 className="serif text-3xl md:text-4xl text-[#F2EBE1] leading-tight">{t("newsletter_title")}</h3>
        <p className="text-sm text-[#8A857D] leading-relaxed mt-3">{t("newsletter_sub")}</p>
      </div>
      <form onSubmit={subscribe} className="flex w-full md:w-auto md:min-w-[420px] items-stretch border-b border-[#3A362F] focus-within:border-[#C49A6C] transition-colors">
        <input type="text" inputMode="email" autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} dir="ltr"
          value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("newsletter_ph")} data-testid="newsletter-email-input"
          className="flex-1 bg-transparent py-3.5 text-sm text-[#F2EBE1] placeholder:text-[#6E685F] outline-none" />
        <button type="submit" disabled={busy} data-testid="newsletter-submit-btn" className="shrink-0 text-xs uppercase tracking-[0.22em] text-[#C49A6C] hover:text-[#E7CBA9] transition-colors disabled:opacity-50 ps-5">
          {t("newsletter_btn")}
        </button>
      </form>
    </div>
  );
};

export const LinkColumn = ({ title, links }) => (
  <div>
    <h4 className="text-xs uppercase tracking-[0.18em] text-[#8A857D] mb-5">{title}</h4>
    <ul className="space-y-3 text-sm text-[#F2EBE1]/80">
      {links.map(([to, label]) => <li key={to}><Link to={to} className="hover:text-[#C49A6C] transition-colors">{label}</Link></li>)}
    </ul>
  </div>
);

const connectCls = "flex items-center gap-2 text-sm text-[#F2EBE1]/80 hover:text-[#C49A6C] transition-colors";

export const ConnectColumn = ({ c, t, lang, toggle }) => (
  <div className="col-span-2 md:col-span-1">
    <h4 className="text-xs uppercase tracking-[0.18em] text-[#8A857D] mb-5">Connect</h4>
    <div className="space-y-3">
      <a href={c.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className={connectCls}><Instagram size={16} strokeWidth={1.4} /> {t("instagram")}</a>
      <a href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className={connectCls}><MessageCircle size={16} strokeWidth={1.4} /> <span dir="ltr">+{c.whatsapp}</span></a>
      <a href={`mailto:${c.email}`} data-testid="footer-email" className={connectCls}><Mail size={16} strokeWidth={1.4} className="shrink-0" /> <span dir="ltr">{c.email}</span></a>
    </div>
    <button onClick={toggle} data-testid="footer-language" className="block mt-5 text-xs uppercase tracking-[0.15em] text-[#8A857D] hover:text-[#F2EBE1] transition-colors">
      {lang === "en" ? "العربية" : "English"}
    </button>
  </div>
);
